import { Pipe, PipeTransform } from '@angular/core';
import { AirlinePreference } from '@ag-common-lib/lib/models/utils/flight-preference.model';

@Pipe({ name: 'isFirstChoiceSelected' })
export class IsFirstChoiceSelectedPipe implements PipeTransform {
  transform(data: Partial<AirlinePreference>, airlinePreferences: AirlinePreference[]): boolean {
    return airlinePreferences.some(airline => airline.isFirstChoiceAirline && airline.airline !== data.airline);
  }
}
